import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Form, Input, Button, Spin, Layout } from 'antd';
import axios from 'axios';
import qs from 'qs';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import { Constant } from '../../config'
import MyModal from '../Modal';

import './Me.css';

const { Content } = Layout;

class ChangePassword extends Component {
	state = {
		loading: false
	}

	componentWillMount(){
    this.props.fetchMenuAction("", "")
  }

  saveFormRef = formRef => {
    this.formRef = formRef;
  };

  formHandleSubmit = () => {
  	const { form } = this.formRef.props;

    form.validateFields((err, values) => {
    	if (err)
    		return

    	MyModal.confirm("คุณต้องการบันทึกข้อมูล ใช่หรือไม่ ?", "", async (f) => {
    		if (!f)
    			return
    		
    		this.setState({ loading: true })

	      let opt = {
	        url: Constant.ADMIN_MY_CHANGE_PASSWORD,
	        method: "POST",
	        data: qs.stringify(values),
	        headers: {
	          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey),
	          'Content-Type': 'application/x-www-form-urlencoded'
	        },
	      }
	      let resp
	      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง`
	      let eMsgDetail = ""
	      let eFlag = false

	      try {
	        resp = await axios(opt)
	      } catch(err) {
	        resp = err.response
	      }

	      if (!resp.data) {
	        eFlag = true
	      } else if (resp.data.error) {
	        eFlag = true
	        let e = resp.data.error
	        eMsgDetail = `[${e.code}] ${e.name}`
	      }

	      if (eFlag) {
	        MyModal.error(eMsg, eMsgDetail, ()=>{
	          window.location.reload()
	        })
	      } else {
	        MyModal.info(`บันทึกข้อมูลสำเร็จ`, "", async ()=>{
	        	form.resetFields()
	          this.setState({ loading: false })
	        })
	      }

    	}, "ใช่", "ไม่ใช่")
    })
  }

	render(){
		return (
			<Layout style={{ padding: '0 24px 24px' }}>
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>เปลี่ยนรหัสผ่าน</h2>
            <ChangePasswordForm 
            	wrappedComponentRef={this.saveFormRef}
            	onCreate={this.formHandleSubmit}
            />
          </Content>
        </Spin>
      </Layout>
		)
	}
}

const ChangePasswordForm = Form.create({name: "change_password_form"})(
	class extends Component {
		render() {
			const { form, onCreate } = this.props
			const { getFieldDecorator } = form

			return (
        <Form layout="vertical" className="change-password-form" onSubmit={onCreate}>
        	<Form.Item label="รหัสผ่านเดิม">
						{getFieldDecorator('old_password', {
							rules: [
	              {
	                required: true,
	                min: 8,
	                max: 16,
	                message: 'กรุณากรอกรหัสผ่าน 8-16 ตัวอักษร',
	              },
	            ],
						})(
							<Input type="password" />
						)}
					</Form.Item>
          <Form.Item label="รหัสผ่านใหม่">
						{getFieldDecorator('password', {
							rules: [
	              {
	                required: true,
	                min: 8,
	                max: 16,
	                message: 'กรุณากรอกรหัสผ่าน 8-16 ตัวอักษร',
	              },
	            ],
						})(
							<Input type="password" />
						)}
					</Form.Item>
					<Form.Item label="ยืนยันรหัสผ่านใหม่">
						{getFieldDecorator('confirm_password', {
							rules: [
	              {
	                required: true,
	                min: 8,
	                max: 16,
	                message: 'กรุณากรอกรหัสผ่าน 8-16 ตัวอักษร',
	              },
	            ],
						})(
							<Input type="password" />
						)}
					</Form.Item>

					<div style={{textAlign: 'center'}}>
	        	<Button type="primary" onClick={onCreate}>บันทึก</Button>
          </div>
        </Form>
      )
		}
	}
)

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
  }
}

export default connect(null, mapDispatchToProps)(ChangePassword)


// WEBPACK FOOTER //
// ./src/containers/Me/ChangePassword.js